'use client';
import React from 'react';
import { Box } from '@mui/joy';
import { CircleAlert, CircleCheck, XCircle } from 'lucide-react';
import { closeSnackbar, SnackbarProvider } from 'notistack';

type NotificationProviderProps = {
	children: React.ReactNode;
};

function NotificationProvider({ children }: NotificationProviderProps) {
	return (
		<SnackbarProvider
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			iconVariant={{
				error: (
					<Box
						sx={{
							marginRight: '10px',

							alignSelf: 'start',
						}}>
						<CircleAlert style={{ width: '24px', height: '24px' }} />
					</Box>
				),
				success: (
					<Box
						sx={{
							marginRight: '10px',
							alignSelf: 'start',
						}}>
						<CircleCheck style={{ width: '24px', height: '24px' }} />
					</Box>
				),
			}}
			maxSnack={2}
			style={{
				maxWidth: '324px',
				width: 'max-content',
				fontWeight: 500,
				fontSize: '14px',
			}}
			autoHideDuration={5000}>
			{children}
		</SnackbarProvider>
	);
}

export default NotificationProvider;
